import axios from 'axios';

// axios instance for making requests
const axiosInstance = axios.create();

export default axiosInstance;
